import { Component, Input } from '@angular/core';
import { IMedia } from 'src/app/core/models/i-media';

@Component({
  selector: 'app-media-thumbnail',
  templateUrl: './media-thumbnail.component.html',
  styleUrls: ['./media-thumbnail.component.scss'],
})
export class MediaThumbnailComponent {
  @Input() media: IMedia;
  @Input() cmsUrl?: string;
}
